<!-- radar-cards.component.html -->
<div class="card-wrapper">
   <div class="card">
      <h5>
         <span>Musaffa ISRI Score</span>
         <span
            ngbTooltip="ISRI reports provided by Musaffa are based on our proprietary scoring system. These reports are intended for informational purposes only and do not constitute legal, investment, or financial advice."
            placement="top" [tooltipClass]="'tooltip_white_bg'" style="display: inline-block; cursor: pointer;">
            <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
         </span>
      </h5>
      <h3>
         <span>
            {{
            musaffaData?.iri_score != null
            ? (musaffaData?.iri_score | number : "1.0-2")
            : "-"
            }}/<span style="color: #939eab">5</span>
         </span>

         <span [ngClass]="getScoreClass(musaffaData?.score_classification)">{{
            musaffaData?.score_classification
            }}</span>
      </h3>

      <div class="radar_chart_row">
         <ul class="legend-list">
            <li *ngFor="let item of radarLegend">
               <span class="dot" [ngStyle]="{ 'background-color': item.color }"></span>
               <span class="legend-list-span">{{ item.label }}</span>
            </li>
         </ul>
         <div class="radar_canvas">
            <div class="chart-wrapper">
               <canvas baseChart [datasets]="radarChartData1" [labels]="radarChartLabels" [options]="radarChartOptions"
                  [type]="'radar'" [legend]="false">
               </canvas>
            </div>
         </div>
      </div>
   </div>

   <div class="card">
      <h5>
         <span>Community ISRI Score</span>
         <span ngbTooltip="This score reflects the average rating given by users on our platform, based on their
assessment of the company’s ethical and moral practices using the same IRI
framework."
            placement="top" [tooltipClass]="'tooltip_white_bg'" style="display: inline-block; cursor: pointer">
            <img src="../../../../assets/icons/IconInfo.svg" alt="Info" />
         </span>
      </h5>
      <h3>
         <span>
  {{ communityData?.iri_score != null ? (communityData.iri_score | number: '1.0-2') : '-'}}/<span style="color: #939eab">5</span>
</span>

         <span [ngClass]="getScoreClass(communityData?.score_classification)">{{
            communityData?.score_classification
            }}</span>
      </h3>

      <div class="radar_chart_row">
         <ul class="legend-list">
            <li *ngFor="let item of radarLegend">
               <span class="dot" [ngStyle]="{ 'background-color': item.color }"></span>
               <span class="legend-list-span">{{ item.label }}</span>
            </li>
         </ul>
         <div class="radar_canvas">
            <div class="chart-wrapper">
               <canvas baseChart [datasets]="radarChartData2" [labels]="radarChartLabels" [options]="radarChartOptions"
                  [type]="'radar'" [legend]="false">
               </canvas>
            </div>
         </div>
      </div>
   </div>
</div>
